import React, { memo, useEffect, useState } from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

import dayjs from 'dayjs';
import { createSelector } from 'reselect';
import { message } from 'antd';
import CardIndex from '../../card/CardIndex/CardIndex';
// import Loading from '../../components/Loading/Loading';
// import { getQueryString } from '../../utils/utils';
import styles from './NSpecial.module.less';
import DetailComment from '../../components/Detail/DetailComment';
import DetailCommentList from '../../components/Detail/DetailCommentList';
import { setSpecialZan } from '../../actions/special';
import { logging } from '../../actions/log';
import fail from '../../static/msg-fail.svg';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ recommZT, specialInfo = {}, bannerId }) => {
  const [zan, setZan] = useState(false);
  const [zanNum, setZanNum] = useState(0);
  const logInfoData = useSelector(selectLogInfo);

  // 监听滚动
  useEffect(() => {
    const img = document.getElementsByClassName('detail_img');
    if (img && img[0]) {
      img[0].style.top = `0px`;
      img[0].style.opacity = 1;
    }
  }, [specialInfo]);
  useEffect(() => {
    return () => {
      const img = document.getElementsByClassName('detail_img');
      if (img && img[0]) {
        img[0].style.top = `0px`;
        img[0].style.opacity = 1;
      }
    };
  }, []);
  useEffect(() => {
    const el = document.getElementById('container_content');
    const handleScroll = () => {
      const img = document.getElementsByClassName('detail_img');
      if (img && img[0]) {
        img[0].style.position = 'relative';
        img[0].style.top = `-${el.scrollTop}px`;
        img[0].style.opacity = 1 - (el.scrollTop / 220 > 0.9 ? 1 : el.scrollTop / 220);
      }
    };
    if (el) {
      el.addEventListener('scroll', handleScroll);
    }
    return () => {
      el.removeEventListener('scroll', handleScroll);
    };
  }, []);
  useEffect(() => {
    setZanNum(specialInfo.zanCount);
    setZan(specialInfo.hasZan === 1);
  }, [specialInfo]);
  const dispatch = useDispatch();
  const handleZan = () => {
    if (zan) {
      message.destroy();
      message.error({
        content: '已赞过该专题',
        icon: <img className="ant-message-custom-img" src={fail} alt="fail" />,
      });
      return;
    }
    setZan(true);
    dispatch(
      setSpecialZan({
        type: 2,
        ztId: specialInfo.ztId,
      }),
    );
    // 打桩
    dispatch(
      logging({
        category: 'C',
        action: 'Special_Zan',
        label: '',
        param2: {
          source: `Special||${specialInfo.ztId || ''}||${bannerId || ''}`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
  };
  // const location = useLocation();
  const handleNumber = (data = 0) => {
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(+data)) {
      return data;
    }
    if (+data < 1000) {
      return data;
    }
    if (+data < 10000) {
      return `${(data / 1000).toFixed(1)}k`;
    }

    return `${(data / 10000).toFixed(1)}w`;
  };

  return (
    <div className={styles.nspecial}>
      <div className={styles.nspecial_header}>
        <div className={styles.nspecial_header_content}>
          <div className={styles.nspecial_header_title}>{specialInfo.ztTitle}</div>
          <div className={styles.nspecial_header_icon}>
            <div className={classNames(styles.nspecial_header_time)}>
              {specialInfo.pushTime && dayjs(specialInfo.pushTime).format('YYYY/MM/DD')}
            </div>
            <div className={classNames(styles.nspecial_header_icon_single)}>
              <div className={classNames(styles.icon_zan)}>
                <i
                  className={classNames('iconfont icon-reads')}
                  style={{ position: 'relative', top: '1px' }}
                />
              </div>
              <span>{handleNumber(specialInfo.watchCount)}</span>
            </div>
            <div
              className={classNames(
                styles.nspecial_header_icon_single,
                zan ? styles.nspecial_header_icon_active : styles.nspecial_header_icon_blur,
              )}
              onClick={handleZan}
            >
              <div className={classNames(styles.icon_zan, { [styles.icon_zan_active]: true })}>
                <i
                  className={classNames('iconfont icon-zan')}
                  style={{ position: 'relative', top: '1px' }}
                />
              </div>
              <span>{handleNumber(zanNum)}</span>
            </div>
          </div>
          <div
            className={styles.nspecial_header_desc}
            dangerouslySetInnerHTML={{ __html: specialInfo.ztLongDesc }}
          />
        </div>
      </div>

      <div className={styles.nspecial_content}>
        {specialInfo &&
          specialInfo.ztList &&
          specialInfo.ztList.slice(1).map((item, i) => (
            <React.Fragment key={i}>
              <CardIndex data={item} key={i} logInfo={{ tag: 'Special' }} />
            </React.Fragment>
          ))}
      </div>
      {specialInfo &&
        specialInfo.ztId &&
        specialInfo.ztType &&
        recommZT &&
        recommZT.map((item, index) => {
          return (
            <CardIndex
              data={{ ...item, ztType: specialInfo.ztType || '' }}
              key={index}
              logInfo={{ tag: 'Special' }}
            />
          );
        })}
      <div>
        <div className={styles.comment}>
          <DetailComment
            appDetailsData={specialInfo}
            source="zt"
            text="写点评论吧"
            maxLength={800}
          />
        </div>
        <DetailCommentList appDetailsData={specialInfo} source="zt" />
      </div>
    </div>
  );
});
